import { ClientSmartHub } from '@classes/client/client';
import { LicenseType } from './licenseType';
import { LicenseStatus } from './licenseStatus';

export class LicenseANPR {
  id: string;
  client: ClientSmartHub;
  type: LicenseType;
  startingDate: Date;
  expiryDate: Date;
  status: LicenseStatus;
  usesRemaining: number;
  comment: string;

  static fromObject(object: LicenseANPR): LicenseANPR {
    return Object.assign(new LicenseANPR(), {
      ...object,
      type: LicenseType.fromObject(object.type),
    });
  }
}
